exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row[data-v-c0d07fae]{margin:0}input[data-v-c0d07fae]:invalid{border:1px solid red}.cc-user-kombox-form[data-v-c0d07fae]{border-left:5px solid #f9f7c0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-c0d07fae&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/KomboxForm.vue
// module id = 218
// module chunks = 0